import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ModelDataService } from './../../base-services/model-data.service';
import { ModalService } from './../../base-services/modal.service';
import { CollectionService } from './../../base-services/collection.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { BaseEntity } from './../../base-models/base-entity';
import { BaseDropdown } from './base-dropdown';
import { Component, OnInit, HostListener } from '@angular/core';
import { MakeProvider } from '../abstract-custom-control';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'yt-fw-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [ MakeProvider(DropdownComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent<T extends BaseEntity> extends BaseDropdown<T> implements OnInit {

  constructor(
    protected baseDataService: BaseDataService,
    public collectionService: CollectionService,
    protected modalService: ModalService,
    protected modelDataService: ModelDataService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(baseDataService, collectionService, modalService, modelDataService, changeDetectorRef);
  }

  private unsubscribe$ = new Subject<void>();
  ngOnInit() {
    super.ngOnInit();
    fromEvent(window, 'resize')
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(event => {
      this.setSize();
    });
  }

  ngAfterViewInit(){
    this.setSize();
  }

  ngAfterViewChecked(){
    //this.setSize();
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event){
  //   this.setSize();
  // }

  compareFn(item1: T, item2: T): boolean{
    if(this.Type == 'item')
      return item1 && item2 ? item1.ID == item2.ID : item1 == item2;
    else
      return item1 == item2;
  }

  setSize(){
    if(this.selectControl.nativeElement.offsetWidth > 0){
      this.placeholder.nativeElement.style.width = this.selectControl.nativeElement.offsetWidth + 'px';
      this.errorIcon.nativeElement.style.left = this.selectControl.nativeElement.offsetWidth - 20 + 'px';
    }
  }

  writeValue(value){
    super.writeValue(value);
    this.changeDetectorRef.markForCheck();
  }

  trackBy(index, item){
    if(this.Type == 'item')
      return item.ID;
    else
      return item;
  }

  OnItemAdded(item){
    super.OnItemAdded(item);
    this.Items.push(item);
    this.value = item.ID;
    this.changeDetectorRef.markForCheck();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
